import { arbitrumSepolia, baseSepolia, optimismSepolia, sepolia, type Chain } from "viem/chains";

export type ChainConfig = {
  key: string;
  name: string;
  domain: number;
  usdc: `0x${string}`;
  tokenMessenger: `0x${string}`;
  viem: Chain;
  explorer: string;
};

const TOKEN_MESSENGER = "0x8FE6B999Dc680CcFDD5Bf7EB0974218be2542DAA" as const;

export const chains: ChainConfig[] = [
  {
    key: "base-sepolia",
    name: "Base Sepolia",
    domain: 6,
    usdc: "0x036CbD53842c5426634e7929541eC2318f3dCF7e",
    tokenMessenger: TOKEN_MESSENGER,
    viem: baseSepolia,
    explorer: "https://sepolia.basescan.org/tx/"
  },
  {
    key: "arbitrum-sepolia",
    name: "Arbitrum Sepolia",
    domain: 3,
    usdc: "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d",
    tokenMessenger: TOKEN_MESSENGER,
    viem: arbitrumSepolia,
    explorer: "https://sepolia.arbiscan.io/tx/"
  },
  {
    key: "op-sepolia",
    name: "OP Sepolia",
    domain: 2,
    usdc: "0x5fd84259d66Cd46123540766Be93DFE6D43130D7",
    tokenMessenger: TOKEN_MESSENGER,
    viem: optimismSepolia,
    explorer: "https://sepolia-optimism.etherscan.io/tx/"
  },
  {
    key: "ethereum-sepolia",
    name: "Ethereum Sepolia",
    domain: 0,
    usdc: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
    tokenMessenger: TOKEN_MESSENGER,
    viem: sepolia,
    explorer: "https://sepolia.etherscan.io/tx/"
  }
];

export const chainByKey = (key: string) => chains.find((chain) => chain.key === key) ?? chains[0]!;
export const chainByDomain = (domain: number) => chains.find((chain) => chain.domain === domain) ?? chains[0]!;

export function cctpEta(domain: number, finality: "standard" | "fast") {
  if (finality === "standard") return "≈15–19 min";
  return domain === 0 ? "≈20 sec" : "≈8 sec";
}
